import { PluginHook } from './PluginHook';

/**
 *
 */
export function WindowTopBarPluginArea(props) {
  return (
    <PluginHook targetName="WindowTopBarPluginArea" {...props} />
  );
}
